import React from 'react'
import { Button } from "@material-ui/core"
import strings from 'strings'
import { joinAttributes } from 'tools/formatters';
import SearchResultInfo from './SearchResultInfo';
import PossibleAlternativeCard from './PossibleAlternativeCard';
import RelatedBusinessCard from './RelatedBusinessCard';
import StatusIndicator from 'components/shared/StatusIndicator/index';

const sosStrings = strings.APPLICANT.SOS

const SearchResultCard = (props) => {

    const { searchResult, possibleAlternatives, relatedBusinesses, viewResult, searchAlternative, searchLoading, state, isQuickSearch, creditCosts } = props

    const address = joinAttributes({ street: searchResult?.physicalAddressStreet, city: searchResult?.physicalAddressCity, state: searchResult?.physicalAddressState, zip: searchResult?.physicalAddressZip })
    const color = searchResult?.normalizedStatus === 'Active' ? 'green' : 'gray'
    const byAgent = relatedBusinesses?.byAgent || []
    const byOfficer = relatedBusinesses?.byOfficer || []

    // Wrapper function to add sosSearchId and relationType to related business before viewing
    const handleViewRelatedBusiness = (business, type) => {
        viewResult({ ...business, sosSearchId: searchResult?.sosSearchId, relationType: type })
    }

    return (
        <div style={{ maxHeight: '600px', overflowY: 'auto', paddingRight: '10px' }}>
            <div className='d-flex justify-content-between'>
                <div className='flex-fill'>
                    <div className='d-flex'>
                        <p className='bold-font mb-0 mr-3'>{searchResult?.title}</p>
                        {searchResult?.normalizedStatus && <StatusIndicator color={color} text={searchResult?.normalizedStatus} side='left' />}
                    </div>
                    <p className='mb-0'>{address}</p>
                </div>
                <div className='d-flex justify-content-end align-items-center'>
                    <div className='greenLabel mr-2'> {sosStrings.BEST_MATCH} </div>
                    <Button
                        variant="outlined"
                        color="primary"
                        className='mr-2'
                        onClick={() => viewResult(searchResult)}
                    >
                        {sosStrings.VIEW_MORE}
                    </Button>
                </div>
            </div>
            <SearchResultInfo searchResult={searchResult} possibleAlternatives={possibleAlternatives} />
            {
                possibleAlternatives?.length > 0 &&
                possibleAlternatives.map((item) => {
                    return (<PossibleAlternativeCard
                        key={item?.sosId}
                        alternative={item}
                        actionToPerform={searchAlternative}
                        actionText={sosStrings.RESEARCH}
                        state={state}
                        isQuickSearch={isQuickSearch}
                        actionLoading={searchLoading}
                        creditCosts={creditCosts}
                    />)
                })
            }
            {byAgent?.length > 0 &&
                byAgent.map((item) => {
                    return (<RelatedBusinessCard
                        key={item?.sosId}
                        business={item}
                        actionToPerform={(business) => handleViewRelatedBusiness(business, 'byAgent')}
                        actionText={sosStrings.VIEW_MORE}
                        relationType="byAgent"
                        isQuickSearch={isQuickSearch}
                        actionLoading={searchLoading}
                        creditCosts={creditCosts}
                    />)
                })
            }
            {byOfficer?.length > 0 &&
                byOfficer.map((item) => {
                    return (<RelatedBusinessCard
                        key={item?.sosId}
                        business={item}
                        actionToPerform={(business) => handleViewRelatedBusiness(business, 'byOfficer')}
                        actionText={sosStrings.VIEW_MORE}
                        relationType="byOfficer"
                        isQuickSearch={isQuickSearch}
                        actionLoading={searchLoading}
                        creditCosts={creditCosts}
                    />)
                })
            }
        </div>
    )
}

export default SearchResultCard